import { useState, useEffect } from 'react';
import { useTeams } from '@/hooks/useTeams';
import { useMultiTeam } from '@/hooks/useMultiTeam';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Users } from 'lucide-react';

interface TeamFilterProps {
  value: string;
  onChange: (teamId: string) => void;
}

/**
 * Team filter dropdown for Dayboard. Shows "All Teams" option.
 * Only visible when multi-team is enabled.
 */
export function TeamFilter({ value, onChange }: TeamFilterProps) {
  const { isMultiTeamEnabled } = useMultiTeam();
  const { teams, isLoading } = useTeams();

  // Don't render if multi-team is not enabled
  if (!isMultiTeamEnabled) {
    return null;
  }

  const activeTeams = teams.filter(t => t.is_active);

  return (
    <div className="flex items-center gap-2">
      <Users className="h-4 w-4 text-muted-foreground" />
      <Select value={value} onValueChange={onChange} disabled={isLoading}>
        <SelectTrigger className="w-[160px] h-8">
          <SelectValue placeholder={isLoading ? 'Loading...' : 'All Teams'} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Teams</SelectItem>
          {activeTeams.map((team) => (
            <SelectItem key={team.id} value={team.id}>
              {team.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
